// Lib
import React from "react";

// CSS
import "./Spinner.css";

const Spinner = () => <div className="loader">Chargement...</div>;

export default Spinner;
